import React, { useState } from 'react';

const CCRExportOptionsModal = React.memo(({ isOpen, onClose, onExport, isExporting }) => {
  const [exportType, setExportType] = useState('frontend'); // 'frontend', 'all-editable', or 'all'

  const handleSubmit = () => {
    onExport(exportType);
  };

  if (!isOpen) return null;

  const options = [
    {
      value: 'frontend',
      title: 'Dashboard Columns Only',
      description: 'Export only the 29 columns visible in the dashboard (excludes UDF fields, timestamps, etc.)',
    },
    {
      value: 'all-editable',
      title: 'All Columns (Including UDFs)',
      description: 'Export all 45 editable columns including user-defined fields (UDF01-UDF16)',
    },
    {
      value: 'all',
      title: 'All Columns (Full Export)',
      description: 'Export all columns including system fields (ID, timestamps, created_by, last_modified_by)',
    },
  ];

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    }}>
      <div style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '2rem',
        width: '90%',
        maxWidth: '550px',
        maxHeight: '90vh',
        overflowY: 'auto',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      }}>
        {/* Header */}
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '1.5rem',
        }}>
          <h3 style={{ margin: 0, color: '#333' }}>
            📊 Export Change Orders Data
          </h3>
          <button
            onClick={onClose}
            disabled={isExporting}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '1.5rem',
              cursor: isExporting ? 'not-allowed' : 'pointer',
              color: '#666',
              padding: '0.25rem',
              opacity: isExporting ? 0.5 : 1,
            }}
          >
            ×
          </button>
        </div>

        {/* Info box */}
        <div style={{
          backgroundColor: '#e3f2fd',
          padding: '1rem',
          borderRadius: '8px',
          marginBottom: '1.5rem',
        }}>
          <p style={{ margin: 0, fontSize: '0.9rem', color: '#1565c0' }}>
            Select which columns to include in your Excel export. The file will be generated and available for download.
          </p>
        </div>

        {/* Export Options */}
        <div style={{ marginBottom: '1.5rem' }}>
          {options.map((option) => (
            <label
              key={option.value}
              style={{
                display: 'block',
                padding: '1rem',
                marginBottom: '0.75rem',
                border: `2px solid ${exportType === option.value ? '#17a2b8' : '#dee2e6'}`,
                borderRadius: '8px',
                cursor: 'pointer',
                backgroundColor: exportType === option.value ? '#e3f2fd' : 'white',
                transition: 'all 0.2s ease',
              }}
              onClick={() => setExportType(option.value)}
            >
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
                <input
                  type="radio"
                  name="exportType"
                  value={option.value}
                  checked={exportType === option.value}
                  onChange={() => setExportType(option.value)}
                  style={{ marginTop: '2px' }}
                />
                <div>
                  <div style={{ fontWeight: '600', color: '#333', marginBottom: '0.25rem' }}>
                    {option.title}
                  </div>
                  <div style={{ fontSize: '0.85rem', color: '#666' }}>
                    {option.description}
                  </div>
                </div>
              </div>
            </label>
          ))}
        </div>

        {/* Action buttons */}
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end' }}>
          <button
            onClick={onClose}
            disabled={isExporting}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: '#6c757d',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: isExporting ? 'not-allowed' : 'pointer',
              opacity: isExporting ? 0.5 : 1,
            }}
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={isExporting}
            style={{
              padding: '0.75rem 1.5rem',
              backgroundColor: '#17a2b8',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: isExporting ? 'not-allowed' : 'pointer',
              opacity: isExporting ? 0.5 : 1,
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
            }}
          >
            {isExporting ? (
              <>
                <span style={{
                  width: '16px',
                  height: '16px',
                  border: '2px solid white',
                  borderTopColor: 'transparent',
                  borderRadius: '50%',
                  animation: 'spin 1s linear infinite',
                }} />
                Exporting...
              </>
            ) : (
              <>📥 Export</>
            )}
          </button>
        </div>
      </div>
      
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
});

export default CCRExportOptionsModal;
